import './ShellMessage.scss'
import { useId, type ReactNode } from 'react'

export interface ShellMessageProps {
  title: ReactNode
  /** Decorative icon (aria-hidden). */
  icon?: ReactNode
  children?: ReactNode
}

/** A full-page message inside the shell: not found, still in the portal. */
export function ShellMessage({ title, icon, children }: ShellMessageProps) {
  const titleId = `shell-message-${useId()}`
  return (
    <section className="shell-message" aria-labelledby={titleId}>
      {icon && (
        <span className="shell-message__icon" aria-hidden="true">
          {icon}
        </span>
      )}
      <h1 id={titleId} className="shell-message__title">
        {title}
      </h1>
      <div className="shell-message__body">{children}</div>
    </section>
  )
}
